import React, {Component} from 'react';
import BackEnd from "../../../backend/BackEnd";
import DataGrid from "../../../datagrid/DataGrid";
import DataColumn from "../../../datagrid/DataColumn";
import ActionLink from "../../../controls/ActionLink";
import ProductAttachModal from "./modals/ProductAttachModal";

class Articles extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showProductAttachModal: false,
        articleId: 0
    };

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-ios-list-outline"/> Справочники /
                                </span> Номенклатура
                            </h1>
                        </div>
                    </div>
                </div>
                <DataGrid ref={grid => this.grid = grid}
                          dataSource={new BackEnd.ArticlesAdmin.GetGridResult()}
                          gridId="ArticleGrid"
                          pageSize={15}>
                    <DataColumn fieldName="name" type="string"
                                caption="Наименование"
                                cell={article => article.name}/>
                    <DataColumn fieldName="skuNumber" type="string"
                                caption="Артикул"
                                cell={article => article.skuNumber}/>
                    <DataColumn fieldName="fullName" type="string"
                                caption="Полное наименование"
                                cell={article => article.fullName}/>
                    <DataColumn fieldName="code" type="string"
                                caption="Код"
                                cell={article => article.code}/>
                    <DataColumn fieldName="description" type="string"
                                caption="Описание"
                                cell={article => article.description}/>
                    <DataColumn fieldName="productFeatures" type="string"
                                caption="Особенности"
                                cell={article => article.productFeatures}/>
                    <DataColumn fieldName="allowed" type="string"
                                caption="Допускается"
                                cell={article => article.allowed}/>
                    <DataColumn fieldName="notAllowed" type="string"
                                caption="Не допускается"
                                cell={article => article.notAllowed}/>
                    <DataColumn fieldName="product" type="string"
                                caption="Эталонный артикул"
                                cell={article =>
                                    <ActionLink onClick={() => this.attachProduct(article)}>
                                        {article.product ? article.product.text : 'Нет'}
                                    </ActionLink>
                                }/>
                    <DataColumn fieldName="isActive" type="string"
                                caption="Активен"
                                cell={article => article.isActive}/>
                </DataGrid>
                <ProductAttachModal articleId={this.state.articleId}
                                    show={this.state.showProductAttachModal}
                                    onAttach={() => this.grid.fetchGridData()}
                                    onHide={() => this.setState({showProductAttachModal: false})}/>
            </div>
        );
    }

    attachProduct({articleId}) {
        this.setState({showProductAttachModal: true, articleId});
    }
}

export default Articles;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Articles/Articles.js